import React  from 'react';
import PurchaseMaintenanceMngTemplate from '../../components/purchaseMaintenanceMng/PurchaseMaintenanceMngTemplate';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';



const PurchaseMaintenanceMngPage = () => {
  return (
    <div>
      <BreadcrumbsContainer title="수주 관리 / MA 매입 계산서 접수 / 접수 리스트" icon="common"/>
      <PurchaseMaintenanceMngTemplate/>
    </div>
  );
};

export default PurchaseMaintenanceMngPage;
